<template>
  <q-popover
    ref="popover"
    class="time-tracking__color-picker q-pa-sm"
    @show="$emit('show', $event)"
    @hide="$emit('hide', $event)"
  >
    <div class="row justify-between items-center gutter-sm">
      <div v-for="(color, index) in colors" :key="index" class="col-auto">
        <div
          class="time-tracking__color-picker__color circle"
          :style="{ 'background-color': color }"
          @click="handleSelectColor(color)"
        ></div>
      </div>
    </div>
  </q-popover>
</template>

<script>
  export default {
    props: {
      value: {
        type: String
      },

      colors: {
        required: true,
        type: Array
      }
    },

    methods: {
      handleSelectColor (color) {
        this.$emit('input', color)

        this.$refs.popover.hide()
      }
    }
  }
</script>

<style lang="stylus">
  .time-tracking
    &__color-picker
      width: 150px
      &__color
        height: 20px
        width: 20px
        cursor: pointer
</style>
